<section class="cart-page">
	<div class="cart-layout">
		<div class="cart-items-panel">
			<header class="cart-header">
				<h1 class="cart-title">{{'Review Your Cart' | translate}}</h1>
				<div class="billing-toggle">
					<button type="button" class="cycle-btn" [class.active]="billingCycle() === 'monthly'"
						(click)="toggleCycle('monthly')">{{'Monthly'| translate}}</button>
					<button type="button" class="cycle-btn" [class.active]="billingCycle() === 'yearly'"
						(click)="toggleCycle('yearly')">{{'Yearly'| translate}}</button>
				</div>
			</header>

			<ul class="cart-item-list">
				@for (item of items(); track item.id) {
				<li class="cart-item" [class.highlighted]="item.highlighted">
					<div class="item-header">
						<h2 class="item-name">{{ item.name }}</h2>
						<p class="item-desc">{{ item.description }}</p>
					</div>
					<div class="item-pricing">

						<div class="quantity-controls">
							@if(item.quantity!==item.maxQuantity){
							<button type="button" (click)="decrement(item)" [disabled]="item.quantity === 1">−</button>
							<span class="qty">{{ item.quantity }}</span>
							<button type="button" (click)="increment(item)"
								[disabled]="item.quantity === item.maxQuantity">+</button>

							}
						</div>
						<div class="price-block">
							<span class="price">
								{{ (billingCycle() === 'monthly' ? item.basePriceMonthly : item.basePriceYearly) |
								number:'1.2-2' }}
							</span>
							<span class="cycle-label">/ {{ cycleLabel()| translate}}</span>
						</div>
					</div>
				</li>
				}
			</ul>

			<div class="coupon-box">
				@if (appliedCoupon() == null) {
				<div class="coupon-input-row">
					<input type="text" placeholder="{{'Coupon code' | translate}}" [value]="couponInput()"
						(input)="couponInput.set($any($event.target).value)" />
					<button type="button" (click)="applyCoupon()" [disabled]="applyingCoupon()">{{'Apply' |
						translate}}</button>
				</div>
				} @else {
				<div class="coupon-applied">
					<span class="coupon-label">{{'Applied' | translate}}: {{ appliedCoupon()?.code }} ({{
						appliedCoupon()?.percentageOff }}% {{'off' | translate}})</span>
					<button type="button" class="remove-coupon" (click)="removeCoupon()">{{'Remove' |
						translate}}</button>
				</div>
				}
			</div>
		</div>

		<aside class="cart-summary-panel">
			<div class="summary-card">
				<h3 class="summary-title">{{'Order Summary' | translate}}</h3>
				<div class="summary-row">
					<span>{{'Subtotal' | translate}}</span>
					<span>{{ subTotal() | number:'1.2-2' }}</span>
				</div>
				@if (discountAmount() > 0) {
				<div class="summary-row discount-row">
					<span>{{'Discount' | translate}}</span>
					<span>- {{ discountAmount() | number:'1.2-2' }}</span>
				</div>
				}
				<div class="summary-total">
					<span>{{'Total' | translate}}</span>
					<span>{{ total() | number:'1.2-2' }}</span>
				</div>
				<div class="payment-policy-row">
					<label class="toggle-switch">
						<input type="checkbox" [checked]="paymentPolicyAccepted()"
							(change)="setPaymentPolicyAccepted($any($event.target).checked)" class="" />
						<span class="slider"></span>
					</label>
					<span>{{'I agree to the' | translate}} <a [routerLink]="['/', currentLang, 'payment-policy']" target="_blank" >{{'payment policy' | translate}}</a></span>
				</div>
				<button type="button" class="checkout-btn" [disabled]="!paymentPolicyAccepted()"
					(click)="checkout()">{{'Secure Checkout' | translate}}</button>
				<p class="guarantee-note">{{'30-day money-back guarantee' | translate}}</p>
			</div>
		</aside>
	</div>
</section>